import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { useAuth } from '@/hooks/useAuth';
import AppShell from '@/components/Layout/AppShell';
import ChatContainer from '@/components/Chat/ChatContainer';
import LoginPage from '@/components/Login/LoginPage';
import AdminPage from '@/components/Admin/AdminPage';
import { initHaptics } from '@/utils/haptics';

function App() {
  const { isAuthenticated, isLoading } = useAuth();
  const token = useAuthStore((s) => s.token);

  useEffect(() => {
    initHaptics();
  }, []);

  useEffect(() => {
    // In a real app, validate token with server here
  }, [token]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[var(--color-bg)]">
        <div className="w-10 h-10 border-4 border-primary-600 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <Routes>
      <Route
        path="/login"
        element={isAuthenticated ? <Navigate to="/" replace /> : <LoginPage />}
      />
      <Route
        path="/admin/*"
        element={
          isAuthenticated ? (
            <ProtectedAdminRoute />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/"
        element={
          isAuthenticated ? (
            <AppShell>
              <ChatContainer />
            </AppShell>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function ProtectedAdminRoute() {
  const { isAdmin } = useAuth();
  return isAdmin ? <AdminPage /> : <Navigate to="/" replace />;
}

export default App;
